import {
  styled,
  ITheme,
  css,
  isPropValid,
  isPropNotEqualTo,
  borderRadius
} from '@unfold/theme';
import { IButtonProps, TButtonAppearances } from './types';
import { isString } from '@unfold/utils';
import { ButtonTheme } from './theme';

const getBorder = (appearance: TButtonAppearances, theme: ITheme): number | string => {
  return ButtonTheme[appearance][theme.name].border ?? 'none';
};

const getBackgroundColor = (appearance: TButtonAppearances, theme: ITheme): string => {
  return ButtonTheme[appearance][theme.name].backgroundColor ?? '';
};

const getColor = (appearance: TButtonAppearances, theme: ITheme): string => {
  return ButtonTheme[appearance][theme.name].color ?? '';
};

const getWidth = (width: string | number | undefined = 'auto'): string => {
  return isString(width) ? width : `${width}px`;
};

const getHeight = (height: string | number | undefined = '33px'): string => {
  return isString(height) ? height : `${height}px`;
};

const getFontSize = (fontSize: string | number | undefined = '14px'): string => {
  return isString(fontSize) ? fontSize : `${fontSize}px`;
};

const staticStyles = css`
  align-items: baseline;
  border-width: 0;
  max-width: 100%;
  outline: none !important;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  display: flex;
  align-items: center;
  font-family: 'Clarkson', Helvetica, Arial, sans-serif;
  line-height: 20px;
`;

export const StyledButton = styled('button', {
  shouldForwardProp: (prop) =>
    isPropValid(prop) && isPropNotEqualTo(prop, ['width', 'height']),
})<IButtonProps>`
  ${staticStyles}
  cursor: ${({ isDisabled }): string => (isDisabled ? 'default' : 'pointer')};
  border: ${({ theme, appearance = 'default' }): string | number =>
    getBorder(appearance, theme)};
  background-color: ${({ theme, appearance = 'default' }): string =>
    getBackgroundColor(appearance, theme)};
  color: ${({ theme, appearance = 'default' }): string => getColor(appearance, theme)};
  font-size: ${({ fontSize }): string => getFontSize(fontSize)};
  font-weight: ${({ fontWeight }): string | number => fontWeight ?? 400};
  width: ${({ width }): string | number => getWidth(width)};
  height: ${({ height }): string | number => getHeight(height)};
  border-radius: ${borderRadius.px()};

  ${({ uppercase = true }): string => uppercase ? 'text-transform: uppercase;' : ''};

  &:hover {
    background-color: ${({ appearance = 'default' }): string =>
      appearance === 'subtle' ? '#ccc' : ''};
    }
`;

export const IconBefore = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const IconAfter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 5px;
`;
export const ButtonChildren = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
`;
export const LoadingContainer = styled.div`
  width: 100%;
  text-align: center;
`;
